import { useRecordContext, useTranslate } from "ra-core";
import { Link } from "react-router";

import { useConfigurationContext } from "../root/ConfigurationContext";
import type { Contact } from "../types";

// [hiperautomacao] What the person said when asked how they found us, the
// channel it was filed under, who referred them, and where they are in the
// funnel — all read from the instance database.
export const ContactOrigin = () => {
  const record = useRecordContext<Contact>();
  const translate = useTranslate();
  const { originChannels = [] } = useConfigurationContext();
  if (!record) return null;

  const channel = originChannels.find((c) => c.value === record.origem_canal);
  const hasOrigin =
    record.origem_declarada || record.origem_canal || record.indicado_por_id;

  return (
    <div className="flex flex-col gap-1">
      {hasOrigin ? (
        <>
          {record.origem_declarada && (
            <p className="italic">“{record.origem_declarada}”</p>
          )}
          {channel && (
            <p className="text-muted-foreground">
              {translate("hiper.origin.channel")}: {channel.label}
            </p>
          )}
          {record.indicado_por_id && (
            <p className="text-muted-foreground">
              {translate("hiper.origin.referred_by")}:{" "}
              <Link
                to={`/contacts/${record.indicado_por_id}/show`}
                className="underline"
              >
                {record.indicado_por}
              </Link>
            </p>
          )}
        </>
      ) : (
        <p className="text-muted-foreground">
          {translate("hiper.origin.none")}
        </p>
      )}
      {record.estado_funil && (
        <p className="text-muted-foreground">
          {translate("hiper.funnel.state")}:{" "}
          {translate(`hiper.funnel.states.${record.estado_funil}`, {
            _: record.estado_funil,
          })}
        </p>
      )}
    </div>
  );
};
